import styled from 'styled-components';
import { useStyledTheme } from '../../../styling';
import { Input, InputCss } from './Input';

const TextFieldInput = styled.input`
  ${InputCss}
  ${({ theme }) => ` 
    background-color: ${theme.secondary};
    border: 1px solid ${theme.secondary};
    color:${theme.textSecondary};
    border-radius: 0;
    border-bottom-left-radius: ${theme.borderRadius[1]};
    border-bottom-right-radius: ${theme.borderRadius[1]};
  `}
`;

const TextFieldLabel = () => {
  const theme = useStyledTheme();

  return `
    background-color:${theme.primary};
    color:${theme.textSecondary};
    font-size:${theme.fontSize[2]};
    padding:${theme.padding[1]};
    padding-left:${theme.padding[2]};
    border-top-left-radius: ${theme.borderRadius[1]};
    border-top-right-radius: ${theme.borderRadius[1]};
  `;
};

type TextFieldProps = {
    id: string,
    label: string,
    value: string,
    labelStyles?: string,
}

export function TextOutput({
  id, label, value, labelStyles = '',
}: TextFieldProps) {
  return (
    <Input
      id={id}
      label={label}
      labelStyles={`${TextFieldLabel()}${labelStyles}}`}
    >
      <TextFieldInput id={id} value={value} disabled />
    </Input>
  );
}
